import { Component, OnInit } from '@angular/core';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { take, tap } from 'rxjs/operators';

import { TipoMensagem } from '../_classes/enum/tipo_mensagem';
import { Mensagem } from '../_classes/mensagem';
import { Servidor } from '../_classes/servidor';
import { Sistema } from '../_classes/sistema';
import { Usuario } from '../_classes/usuario';
import { MensagemService } from '../_servicos/mensagem.service';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { AvaliacaoSistema } from './../_classes/avaliacao-sistema';
import { EnvService } from './../_servicos/env.service';

const //nome do recurso utilizado (mesmo que a rota)
  recurso = 'avaliacao-sistema';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss'],
})
export class RatingComponent implements OnInit {
  carregando = false;
  servidor$: Observable<Servidor>;
  servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  //mensagem: string = 'Sua opinião é muito importante!';

  avaliacao: AvaliacaoSistema = null;
  dataSource$: Observable<AvaliacaoSistema>;
  dataSourceMG$: Observable<string>;

  mediaGeral: string;

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private msgService: MensagemService,
    private env: EnvService
  ) {
    //console.log('constructor  - rating component');
    this.atualizar();
  }

  ngOnInit() {}

  executarAoCarregarDatasource(x) {
    //console.log('busquei informação de avaliação', x);
    ////console.log('valores individuais');
    if (x) {
      x.forEach((a) => {
        // console.log('individual->', a);

        this.avaliacao = new AvaliacaoSistema(a);
        //        //console.log('this.avaliacao');
        ////console.log(this.avaliacao);
      });
    }
    //console.log('avaliação final ficou: ', this.avaliacao);
    this.carregando = false;
  }

  executarAoCarregarServidor(x) {
    this.servidor = new Servidor(x);
    this.carregando = false;
  }

  mediaGeralAtualizar() {
    this.dataSourceMG$ = this.service.getMediaGeral().pipe(take(1));

    this.dataSourceMG$.subscribe(
      (a) => (this.mediaGeral = a),
      (e) => {
        this.handleError(e);
        return EMPTY;
      }
    );
  }

  atualizar() {
    this.carregando = true;
    /*const source = timer(10000);
    const subscribe = source.subscribe(v => {
      this.carregando = false;
    });*/
    this.mediaGeralAtualizar();
    this.servidor = this.env.servidor;
    /*
    if (!this.avaliacao) {
      //console.log("!this.avaliacao");
      this.avaliacao = new AvaliacaoSistema();
      this.avaliacao.sistema = new Sistema();
      this.avaliacao.sistema.codSist = 57;
      this.avaliacao.usuario = new Usuario(this.servidor.usuario);
      this.avaliacao.dtAvaliacao = new Date();
      this.avaliacao.snAtivo = "S";
      this.avaliacao.nrAvaliacao = 0;
    }*/

    if (this.env.servidor) {
      this.executarAoCarregarServidor(this.env.servidor);
    } else {
      //'CKOLLING-ratting');
      this.servidor$ = this.servService.getServidor().pipe(
        tap((x) => this.executarAoCarregarServidor(x)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
    }

    this.carregando = true;

    if (this.servidor) {
      this.carregando = true;
      if (this.servidor) {
        this.dataSource$ = this.service
          .getAvaliacaoSistema(this.servidor.idServidor)
          .pipe(take(1));
        ////console.log('buscar avaliacoes');
        this.dataSource$.subscribe(
          (a: AvaliacaoSistema) => {
            this.executarAoCarregarDatasource(a);
          },
          (e) => {
            this.handleError(e);
            return EMPTY;
          }
        );
      }
    }
    this.carregando = false;
  }

  onClick(r: number): void {
    let a: AvaliacaoSistema = new AvaliacaoSistema(this.avaliacao);

    if (a.nrAvaliacao !== r) {
      a.nrAvaliacao = r;
    } else {
      a.nrAvaliacao = 0;
    }

    a.sistema = new Sistema();
    a.sistema.idSistema = 57;

    a.usuario = new Usuario(this.servidor.usuario);

    this.service.setAvaliacaoSistema(a).subscribe(
      (x) => {
        this.mediaGeral = '0,00';
        this.atualizar();
        let m: Mensagem = new Mensagem();
        m.mensagem =
          a.nrAvaliacao === 0
            ? 'Nota ZERO computada.'
            : 'Nota ' + a.nrAvaliacao + ' computada.';
        m.mensagem = m.mensagem + ' Obrigado por sua avaliação';
        m.tipo = TipoMensagem.SUCESSO;
        this.msgService.registrarMensagem(m);
      },
      (e) => {
        this.handleError(e);
        return EMPTY;
      }
    );
  }

  handleError(e: any) {
    this.erros$.next(true);
    // let mostrarInativo: boolean = false;
    // if (e instanceof HttpErrorResponse) {
    //   if ((e as HttpErrorResponse).status === 0) {
    //     mostrarInativo = true;
    //   }
    // }
    // if (!mostrarInativo) {
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
    // } else {
    //   this.alertService.mostrarServidorInativo(recurso);
    // }
  }

  // handleError(e: Error) {
  //   let m: Mensagem = new Mensagem();
  //   m.mensagem = e.message;
  //   m.tipo = TipoMensagem.ERRO;
  //   this.msgService.registrarMensagem(m);
  // }
}
